import React, { useRef, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import Footer from "../../Components/Footer/footer";

import Header from "../../Components/Header/header";
import "./CreateOrganization.css";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const SuperAdminOrgSetup = () => {
    const [orgName, setOrgName] = useState("");
    const [orgAddress, setOrgAddress] = useState("");
    const [orgPhno, setOrgPhno] = useState("");
    const [orgEmail, setOrgEmail] = useState("");
    const [orgGstNo, setOrgGstNo] = useState("");
    const [selectedPolicyType, setSelectedPolicyType] = useState("");
    const [orgPanNumber, setOrgPanNumber] = useState(""); // new state
    const orgPanRef = useRef(null);
    const [logoFile, setLogoFile] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isFormDirty, setIsFormDirty] = useState(false);
    const [organizations, setOrganizations] = useState([]);
    const [pincode, setPincode] = useState("");
    const [editingOrgId, setEditingOrgId] = useState(null);
    const [approvalSubmitting, setApprovalSubmitting] = useState(false);
    const [newOrgData, setNewOrgData] = useState(null);
    const [showCredentialPopup, setShowCredentialPopup] = useState(false);
    const [credName, setCredName] = useState("");
    const [credEmail, setCredEmail] = useState("");
    const [credPassword, setCredPassword] = useState("");
    const [credRole, setCredRole] = useState("user");
    const [credEmpId, setCredEmpId] = useState("");
    const [credOrgId, setCredOrgId] = useState("");
    const [credentials, setCredentials] = useState([]);
    const [editingUserId, setEditingUserId] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [insurers, setInsurers] = useState([]);
    const [editId, setEditId] = useState(null);
    const [showInsurerPopup, setShowInsurerPopup] = useState(false);
    const [insCompanyName, setInsCompanyName] = useState("");
    const [insName, setInsName] = useState("");
    const [insEmail, setInsEmail] = useState("");
    const [insPhone, setInsPhone] = useState("");
    const [insAddress, setInsAddress] = useState("");
    const [insurersData, setInsurersData] = useState([]);
    const [insOrgId, setInsOrgId] = useState("");
    const [isEdited, setIsEdited] = useState(false);
    const [orgIdError, setOrgIdError] = useState("");
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [insurer, setInsurer] = useState("");
    const [irdaiRegNo, setIrdaiRegNo] = useState("");
    const [error, setError] = useState("");
    const [editingInsurerId, setEditingInsurerId] = useState(null);
    const [irdai, setIrdai] = useState("");
    const [showTpaPopup, setShowTpaPopup] = useState(false);
    const [tpaData, setTpaData] = useState([]);
    const orgNameRef = useRef(null);
    const [tpaName, setTpaName] = useState("");
    const [tpaEmail, setTpaEmail] = useState("");
    const [tpaPhone, setTpaPhone] = useState("");
    const [tpaAddress, setTpaAddress] = useState("");
    const [registrationNo, setRegistrationNo] = useState("");
    const [corUpto, setCorUpto] = useState("");
    const [orgSearch, setOrgSearch] = useState("");
    const isEditingThisOrg = (fieldOrgId) => editingOrgId === fieldOrgId; 
    const REQUIRED_COLUMNS = [
        "emp_email_id",
        "emp_name",
        "joining_date",
        "designation",
        "dob",
        "emp_status",
        "relation",
        "cat_org_custom_name",
    ];
    const [selectedColumns, setSelectedColumns] = useState([...REQUIRED_COLUMNS]);
    const [showTemplatePopup, setShowTemplatePopup] = useState(false);
    const [insurerMasters, setInsurerMasters] = useState([]);
    const [policyTypes, setPolicyTypes] = useState([]);
    const [columnList, setColumnList] = useState([]); 
    const [selectedInsurer, setSelectedInsurer] = useState("");
    const [selectedPolicy, setSelectedPolicy] = useState("");
    const [editingTpaId, setEditingTpaId] = useState(null);
    const [errors, setErrors] = useState({});
    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;
    const resetInsurerForm = () => {
        setInsOrgId("");
        setInsCompanyName("");
        setInsName("");
        setInsEmail("");
        setInsPhone("");
        setInsAddress("");
        setOrgIdError("");
        setEditingInsurerId(null);
        setIsEdited(false);
    };

    useEffect(() => {
        fetch("/api/insurer-master")
            .then((res) => res.json())
            .then((data) => setInsurerMasters(data))
            .catch((err) => console.error(err));
    }, []);


    // fetch policy types
    useEffect(() => {
        fetch("/api/policy_type")
            .then((res) => res.json())
            .then((data) => setPolicyTypes(Array.isArray(data) ? data : []))
            .catch((err) => console.error(err));
    }, []);

    const fetchColumns = async () => {
        try {
            const response = await fetch("/api/employee-columns");
            const data = await response.json();
            setColumnList(data);
        } catch (err) {
            console.error(err);
        }
    };
    const openTemplatePopup = () => {
        setShowTemplatePopup(true);
        fetchColumns();
    };

    const closeTemplatePopup = () => {
        setShowTemplatePopup(false);
        setSelectedColumns([]);
        setSelectedInsurer("");
        setSelectedPolicyType("");
    };


    const handleCheckboxChange = (column) => {
        setSelectedColumns((prev) =>
            prev.includes(column) ? prev.filter((c) => c !== column) : [...prev, column]
        );
    };

    const hasMinimumColumns = selectedColumns.length >= 9;
    const hasAllRequiredColumns = REQUIRED_COLUMNS.every((col) =>
        selectedColumns.includes(col)
    );

    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 7;

    // Calculate indexes
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

    // Slice data
    const currentRecords = insurersData.slice(
        indexOfFirstRecord,
        indexOfLastRecord
    );

    // Total pages
    const totalPages = Math.ceil(insurersData.length / recordsPerPage);

    const [tpaCurrentPage, setTpaCurrentPage] = useState(1);
    const tpaRecordsPerPage = 7;

    const tpaIndexOfLastRecord = tpaCurrentPage * tpaRecordsPerPage;
    const tpaIndexOfFirstRecord = tpaIndexOfLastRecord - tpaRecordsPerPage;

    const currentTpaRecords = tpaData.slice(
        tpaIndexOfFirstRecord,
        tpaIndexOfLastRecord
    );

    const tpaTotalPages = Math.ceil(tpaData.length / tpaRecordsPerPage);


    const filteredOrganizations = organizations.filter((org) =>
        org.org_name?.toLowerCase().includes(orgSearch.toLowerCase()) ||
        org.org_email?.toLowerCase().includes(orgSearch.toLowerCase())   
    );
    

    const isTemplateValid =
        hasMinimumColumns &&
        hasAllRequiredColumns &&
        selectedInsurer &&
        selectedPolicyType;

    // Create Excel template
    const createExcelTemplate = () => {
        if (!selectedInsurer || !selectedPolicyType) {
            alert("Please select Insurer and Policy Type");
            return;
        }

        if (!hasMinimumColumns) {
            alert("Please select at least 9 columns");
            return;
        }

        if (!hasAllRequiredColumns) {
            alert("Please select all mandatory fields");
            return;
        }

        // Top row with Insurer & Policy
        const topRow = [
            `Insurer: ${selectedInsurer}`,
            `Policy: ${selectedPolicyType}`,
            ...Array(selectedColumns.length - 2).fill(""),
        ];

        const headerRow = [...selectedColumns];
        const emptyRow = selectedColumns.map(() => "");

        const worksheet = XLSX.utils.aoa_to_sheet([topRow, headerRow, emptyRow]);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Employee Template");

        // Download Excel
        XLSX.writeFile(workbook, "employee_template.xlsx");

        closeTemplatePopup();
    };
   

  

    const fetchInsurers = async () => {
        try {
            const res = await fetch("/api/getallinsurer");
            const result = await res.json();

            // ✅ backend returns { success, data }
            setInsurersData(Array.isArray(result.data) ? result.data : []);
        } catch (err) {
            console.error("Error fetching insurers:", err);
            setInsurersData([]);
        }
    };
    useEffect(() => {
        fetchInsurers();
    }, []);

   
    const fetchOrganizations = async () => {
        try {
            const res = await fetch("/api/org");
            const data = await res.json();
            console.log("Fetched Orgs:", data);
            setOrganizations(data || []);
        } catch (err) {
            console.error("Error fetching organizations:", err);
        }
    };

    useEffect(() => {
        fetchOrganizations();
    }, []);

    const fetchCredentials = async () => {
        try {
            const res = await fetch("/api/credential/eblogin");
            const data = await res.json();
            console.log("Fetched credentials:", data);
            setCredentials(data || []);
        } catch (err) {
            console.error("Error fetching credentials:", err);
        }
    };

    useEffect(() => {
        fetchCredentials();
    }, []);



    useEffect(() => {
        fetchTpaData();
    }, []);

    const fetchTpaData = async () => {
        try {
            const response = await fetch("/api/tpa/getalltpa");
            const data = await response.json();

            console.log("TPA API response:", data); // DEBUG

            if (response.ok && data.success) {
                setTpaData(data.data);
            } else {
                setError("Failed to fetch TPA data");
            }
        } catch (err) {
            console.error(err);
            setError("Server error");
        }
    };

    const sendApprovalEmail = async (orgId) => {
        try {
            const res = await fetch("/api/org/send-approval", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    org_id: orgId
                }),
            });

            const data = await res.json();
            if (data.success) {
                alert("Approval email sent to manager successfully!");
            } else {
                alert("Approval email failed");
            }
        } catch (err) {
            console.error("Approval email error:", err);
        }
    };

    const validateForm = () => {
        if (!insurer.trim()) return "Insurer name is required.";

        // Allow exactly 3 digits (e.g., 123)
        const irdaiPattern = /^[0-9]{3}$/;
        if (!irdaiPattern.test(irdai)) return "IRDAI number must be exactly 3 digits.";

        return null;
    };


    const handleLogoUpload = (e) => {
        const file = e.target.files[0];
        if (file) setLogoFile(file);
        setIsFormDirty(true);
    };

    const handleInputChange = (setter) => (e) => {
        setter(e.target.value);
        setIsFormDirty(true);
    };

    const handleOrgSubmit = async (e) => {
        e.preventDefault();
        if (!orgName || !orgAddress) {
            alert("Please fill all mandatory fields");
            return;
        }
        if (!orgPhno || orgPhno.length !== 10) {
            alert("Phone number must be exactly 10 digits");
            return;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.com$/;
        if (orgEmail && !emailRegex.test(orgEmail)) {
            alert("Invalid email! Must have @ and .com");
            return;
        }

        if (!orgGstNo) {
            alert("GST number is required");
            return;
        }

        // ✅ GST Format Check
        if (!gstRegex.test(orgGstNo)) {
            alert("Invalid GST number format (e.g. 29AAIAP5202C1ZT)");
            return;
        }

        
        if (!orgPanNumber) {
            alert("PAN number is required");
            return;
        }

        // Standard PAN format: 5 letters + 4 digits + 1 letter
        const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
        if (!panRegex.test(orgPanNumber.toUpperCase())) {
            alert("Invalid PAN format! Example: ABCDE1234F");
            return;
        }

        setIsSubmitting(true);
        try {
            const formData = new FormData();
            if (logoFile) formData.append("logo", logoFile);
            formData.append("org_name", orgName);
            formData.append("org_address", orgAddress);
            formData.append("org_phno", orgPhno);
            formData.append("org_email", orgEmail);
            formData.append("org_gstno", orgGstNo);
            formData.append("pan_number", orgPanNumber.toUpperCase());
            


            let url = "/api/org";
            let method = "POST";
            if (editingOrgId) {
                url = `/api/org/${editingOrgId}`;
                method = "PUT";
            }

            const res = await fetch(url, { method, body: formData });
            const data = await res.json();

            if (res.ok && data.success) {
                alert(editingOrgId ? "Organization updated!" : "Organization created!");
                if (!editingOrgId) {
                    await sendApprovalEmail(data.data.org_id);
                }

                fetchOrganizations();
                resetForm();
            } else {
                alert("Failed: " + (data.error || data.message || "Unknown error"));
            }
        } catch (err) {
            console.error("Error saving org:", err);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleEdit = (org) => {
        setEditingOrgId(org.org_id);
        setOrgName(org.org_name);
        setOrgAddress(org.org_address);
        setOrgPhno(org.org_phno);
        setOrgEmail(org.org_email);
        setOrgGstNo(org.org_gstno);
        setOrgPanNumber(org.pan_number);
        setIsFormDirty(true);
        setTimeout(() => {
            if (orgNameRef.current) {
                orgNameRef.current.focus();
            }
        }, 100);
    };

    const resetForm = () => {
        setOrgName("");
        setOrgAddress("");
        setOrgPhno("");
        setOrgEmail("");
        setOrgGstNo("");
        setLogoFile(null);
        setEditingOrgId(null);
        setIsFormDirty(false);
    };

    // -------------------------
    // Delete Organization
    // -------------------------
    const handleDelete = async (orgId) => {
        if (!window.confirm("Are you sure you want to delete this organization?")) return;

        try {
            const res = await fetch(`/api/org/${orgId}`, { method: "DELETE" });
            const data = await res.json();

            if (res.ok && data.success) {
                alert("Organization deleted successfully!");
                fetchOrganizations();
            } else {
                alert("Failed to delete organization: " + (data.error || "Unknown error"));
            }
        } catch (err) {
            console.error("Error deleting organization:", err);
            alert("Error deleting organization. Check console.");
        }
    };


    // -------------------------
    // Credential Handling
    // -------------------------
    const handleCreateCredential = async () => {
        if (!credName || !credEmail || !credPassword || !credEmpId || !credOrgId) {
            alert("Please fill all fields!");
            return;
        }

        let url = "/api/eblogin/credential";
        let method = "POST";
        if (editingUserId) {
            url = `/api/eblogin/credential/${editingUserId}`;
            method = "PUT";
        }

        try {
            const res = await fetch(url, {
                method,
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    user_name: credName,
                    user_email_id: credEmail,
                    password: credPassword,
                    role: credRole,
                    emp_id: credEmpId,
                    org_id: credOrgId,
                }),
            });

            const data = await res.json();
            if (res.ok && data.success) {
                alert(editingUserId ? "Credential updated successfully!" : "Credential created successfully!");
                setShowCredentialPopup(false);
                setCredName("");
                setCredEmail("");
                setCredPassword("");
                setCredRole("user");
                setCredEmpId("");
                setCredOrgId("");
                setEditingUserId(null);
            } else {
                alert("Failed: " + (data.error || "Unknown error"));
            }
        } catch (err) {
            console.error(err);
            alert("Error creating/updating credential. Check console.");
        }
    };
    const handleSubmit = async () => {
        const validationError = validateForm();
        if (validationError) {
            setError(validationError);
            return;
        }

        try {
            const url = isEdited
                ? `/api/insurer/updateinsurer/${editingInsurerId}`
                : "/api/insurer/createinsurer";

            const method = isEdited ? "PUT" : "POST";

            const response = await fetch(url, {
                method,
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ insurer, irdai }),
            });

            const contentType = response.headers.get("content-type");
            let data = {};
            if (contentType && contentType.includes("application/json")) {
                data = await response.json();
            } else {
                console.error("Server returned non-JSON response:", await response.text());
                setError("Server error. Try again later.");
                return;
            }

            if (response.ok && data.success) {
                alert(data.message);
                setShowPopup(false);
                setInsurer("");
                setIrdai("");
                setError("");
                setIsEdited(false);
                setEditingInsurerId(null);

                // Update table without reload
                if (isEdited) {
                    setInsurersData((prev) =>
                        prev.map((ins) => (ins.company_id === editingInsurerId ? data.data : ins))
                    );
                } else {
                    setInsurersData((prev) => [...prev, data.data]);
                }
            } else {
                setError(data.error || "Error creating/updating insurer.");
            }
        } catch (err) {
            console.error("Network/server error:", err);
            setError("Server error. Try again later.");
        }
    };

    const handleSubmitTpa = async () => {
        // validation: include pincode if required
        if (!tpaName || !tpaEmail || !tpaPhone || !tpaAddress || !registrationNo || !corUpto || !pincode) {
            setError("All fields are required");
            return;
        }

        const url = isEdited
            ? `/api/tpa/updatetpa/${editingTpaId}`
            : "/api/tpa/createtpa";

        const method = isEdited ? "PUT" : "POST";

        const response = await fetch(url, {
            method,
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                tpa_name: tpaName,
                tpa_email_id: tpaEmail,
                tpa_phone: tpaPhone,
                tpa_address: tpaAddress,
                registration_no: registrationNo,
                cor_upto: corUpto,
                pincode: pincode // ✅ Add pincode here
            })
        });

        const data = await response.json();

        if (response.ok && data.success) {
            alert(data.message);

            if (isEdited) {
                setTpaData(prev =>
                    prev.map(t =>
                        t.tpa_id === editingTpaId ? data.data : t
                    )
                );
            } else {
                setTpaData(prev => [...prev, data.data]);
            }

            // reset popup and states
            setShowTpaPopup(false);
            setIsEdited(false);
            setEditingTpaId(null);
            setTpaName("");
            setTpaEmail("");
            setTpaPhone("");
            setTpaAddress("");
            setRegistrationNo("");
            setCorUpto("");
            setPincode(""); // ✅ reset pincode
        } else {
            setError(data.error);
        }
    };



    const handleDeleteCredential = async (user_id) => {
        if (!window.confirm("Are you sure you want to delete this credential?")) return;

        try {
            const res = await fetch(`/api/eblogin/${user_id}`, { method: "DELETE" });
            const data = await res.json();

            if (res.ok && data.success) {
                alert("Credential deleted successfully!");
                fetchCredentials();
            } else {
                alert("Failed to delete credential: " + (data.error || "Unknown error"));
            }
        } catch (err) {
            console.error("Error deleting credential:", err);
            alert("Error deleting credential. Check console.");
        }
    };

  
    const handleSaveInsurer = async () => {
        if (!insOrgId) {
            setOrgIdError("Organization ID is required");
            return;
        }

        // 🔴 CHECK ORG STATUS BEFORE SAVE
        try {
            const checkRes = await fetch(
                `/api/org/check-approved/${insOrgId}`
            );
            const checkData = await checkRes.json();

            if (!checkData.success) {
                setOrgIdError("No approved organization found for this Org ID");
                return;
            }
        } catch (err) {
            setOrgIdError("Unable to validate Organization ID");
            return;
        }
        if (!insCompanyName.trim()) {
            alert("Company Name is required");
            return;
        }
        if (!insName.trim()) {
            alert("Insurer Name is required");
            return;
        }
        if (!insEmail.trim()) {
            alert("Email is required");
            return;
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(insEmail)) {
            alert("Please enter a valid email address");
            return;
        }
        if (!insPhone || insPhone.length !== 10) {
            alert("Phone number must be 10 digits");
            return;
        }

        const body = {
            company_name: insCompanyName,
            insurer_name: insName,
            insurer_email: insEmail,
            insurer_phno: insPhone,
            insurer_address: insAddress,
            org_id: insOrgId
        };

        const url = editingInsurerId
            ? `/api/insurer/${editingInsurerId}`
            : `/api/insurer`;

        const method = editingInsurerId ? "PUT" : "POST";

        try {
            const res = await fetch(url, {
                method,
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body),
            });

            const data = await res.json();

            if (data.success) {
                // ✅ Show proper message from backend
                alert(data.message || "Insurer saved successfully!");
                setShowInsurerPopup(false);
                fetchInsurers();
            } else {
                alert(data.error || "Failed to save insurer");
            }
        } catch (err) {
            console.error(err);
            alert("Failed to save insurer");
        }
    };

    const handleDeleteInsurer = async (company_id) => {
        // Confirm deletion
        if (!window.confirm("Are you sure you want to delete this insurer?")) return;

        try {
            const response = await fetch(`/api/insurer/deleteinsurer/${company_id}`, {
                method: "DELETE",
            });

            const data = await response.json();

            if (response.ok && data.success) {
                // Remove deleted insurer from the state to update table
                setInsurersData((prev) => prev.filter((ins) => ins.company_id !== company_id));
                alert(data.message);
            } else {
                setError(data.error || "Error deleting insurer.");
            }
        } catch (err) {
            console.error("Network/server error:", err);
            setError("Server error. Try again later.");
        }
    };
    const handleDeleteTpa = async (tpa_id) => {
        if (!window.confirm("Are you sure you want to delete this TPA?")) return;

        try {
            const response = await fetch(
                `/api/tpa/deletetpa/${tpa_id}`,
                { method: "DELETE" }
            );

            const data = await response.json();

            if (response.ok && data.success) {
                setTpaData(prev =>
                    prev.filter(tpa => Number(tpa.tpa_id) !== Number(tpa_id))
                );
                alert(data.message);
            } else {
                setError(data.error || "Error deleting TPA");
            }
        } catch (err) {
            console.error(err);
            setError("Server error");
        }
    };


    return (
        <div className="orgsetup-container">
            <aside className="sidebar">
                <Header />
            </aside>
            <main className="orgsetup-content">
                <h2>Manage Organization</h2>

                {/* ORG FORM */}
                <div className="org-form card">
                    <div className="form-row">
                       
                        <div className="form-group">
                            <label>Organization Name: <span style={{ color: "red" }}>*</span></label>
                            <input type="text" value={orgName} onChange={handleInputChange(setOrgName)} 
                            className={editingOrgId ? "highlight-input" : ""}    
                                ref={orgNameRef} // ✅ attach ref here
                            />
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label>Organization Address: <span style={{ color: "red" }}>*</span></label>
                            <input type="text" value={orgAddress} onChange={handleInputChange(setOrgAddress)} 
                                className={editingOrgId ? "highlight-input" : ""}
                            />
                        </div>
                        <div className="form-group">
                            <label>Phone: <span style={{ color: "red" }}>*</span></label>
                            <input
                                type="text"
                                maxLength={10}
                                value={orgPhno}
                                onChange={(e) => {
                                    const value = e.target.value.replace(/\D/g, "");
                                    setOrgPhno(value);
                                    setIsFormDirty(true);
                                }}
                                className={editingOrgId ? "highlight-input" : ""}
                            />
                        </div>

                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label>Email: <span style={{ color: "red" }}>*</span></label>
                            <input type="email" value={orgEmail} onChange={handleInputChange(setOrgEmail)}
                                className={editingOrgId ? "highlight-input" : ""} />
                        </div>
                        <div className="form-group">
                            <label>GST No:<span style={{ color: "red" }}>*</span> </label>
                            <input
                                type="text"
                                maxLength={15}
                                value={orgGstNo}
                                onChange={(e) => {
                                    const value = e.target.value.toUpperCase();
                                    setOrgGstNo(value);
                                }}
                                className={editingOrgId ? "highlight-input" : ""}
                                onBlur={() => {
                                    if (orgGstNo && !gstRegex.test(orgGstNo)) {
                                        alert("Invalid GST number format");
                                    }
                                }}
                            />
                        </div>

                        <div className="form-group">
                            <label>Organization PAN Number: <span style={{ color: "red" }}>*</span></label>
                            <input
                                type="text"
                                value={orgPanNumber}
                                onChange={handleInputChange(setOrgPanNumber)}
                                className={editingOrgId ? "highlight-input" : ""}
                                ref={orgPanRef} // optional ref if needed
                                placeholder="Enter PAN (e.g. ABCDE1234F)"
                            />
                        </div>
                   

                    </div>

                    {(isFormDirty || editingOrgId) && (
                        <div className="org-update-banner">
                            <button className="org-submit-btn top-btn" onClick={handleOrgSubmit}>
                                {editingOrgId ? "Update Organization" : "Save Organization"}
                            </button>
                        </div>
                    )}
                </div>

<br></br>
                {/* ORG TABLE */}
                {/* Header with Search */}
                <div className="org-header">
                    <h3>All Organizations</h3>

                    <input
                        type="text"
                        placeholder="Search organization..."
                        value={orgSearch}
                        onChange={(e) => setOrgSearch(e.target.value)}
                        className="org-search"
                    />
                </div>

                <table className="org-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Address</th>
                            <th>Logo</th>
                            <th>Phone</th>
                            <th>Email</th>
                            <th>GST No</th>
                            <th>Pan Number</th>
                            <th>Status</th>
                            <th>Remarks</th>
                            <th>Actions</th>
                        </tr>
                    </thead>

                    <tbody>
    {filteredOrganizations.length === 0 ? (
        <tr>
            <td colSpan="11" style={{ textAlign: "center" }}>
                No organizations found.
            </td>
        </tr>
    ) : (
        [...filteredOrganizations]
            .sort((a, b) =>
                a.org_name?.toLowerCase().localeCompare(b.org_name?.toLowerCase())
            )
            .map((org) => {
                const isRejected = org.status === "REJECTED";

                return (
                    <tr key={org.org_id}>
                        <td>{org.org_id}</td>
                        <td>{org.org_name}</td>
                        <td className="address-cell">{org.org_address}</td>

                        <td>
                            {org.logo_path ? (
                                <img
                                    src={`${org.logo_path}`}
                                    alt="logo"
                                    width="50"
                                />
                            ) : (
                                "No Logo"
                            )}
                        </td>

                        <td>{org.org_phno}</td>
                        <td>{org.org_email}</td>
                        <td>{org.org_gstno}</td>
                        <td>{org.pan_number}</td>

                        <td style={{ color: isRejected ? "red" : "inherit" }}>
                            {org.status}
                        </td>

                        <td>{org.remarks}</td>

                        <td style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                            {!isRejected && (
                                <>
                                    <FontAwesomeIcon
                                        icon={faEdit}
                                        style={{
                                            color: "#000",
                                            cursor: "pointer",
                                            marginRight: "10px",
                                        }}
                                        title="Edit"
                                        onClick={() => handleEdit(org)}
                                    />

                                    <FontAwesomeIcon
                                        icon={faTrash}
                                        style={{ color: "#000", cursor: "pointer" }}
                                        title="Delete"
                                        onClick={() => handleDelete(org.org_id)}
                                    />
                                </>
                            )}
                        </td>
                    </tr>
                );
            })
    )}
</tbody>
                </table>

                <br />              
                <br></br>
              
                <button className="create-insurer-btn" onClick={() => setShowPopup(true)}>
                    Add Insurer
                </button>


                {/* INSURER POPUP */}
                {showPopup && (
                    <div className="insurer-popup-overlay">
                        <div className="insurer-popup-card">
                            <h3 className="insurer-popup-title">Add Insurer</h3>

                            <div className="insurer-form-group">
                                <label className="insurer-label">Insurer Name:</label>
                                <input
                                    type="text"
                                    className="insurer-input"
                                    value={insurer}
                                    onChange={(e) => setInsurer(e.target.value)}
                                />
                            </div>

                            <div className="insurer-form-group">
                                <label className="insurer-label">IRDAI Reg No:</label>
                                <input
                                    type="text"
                                    className="insurer-input"
                                    value={irdai}
                                    onChange={(e) => setIrdai(e.target.value)}
                                />
                            </div>

                            {error && <p className="insurer-error">{error}</p>}

                            <div className="insurer-button-group">
                                <button className="insurer-save-btn" onClick={handleSubmit}>
                                    Save
                                </button>
                                <button
                                    className="insurer-cancel-btn"
                                    onClick={() => setShowPopup(false)}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* INSURER TABLE */}
                <h3>List off All Insurers</h3>

                <table className="credential-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Insurer Name</th>
                            <th>IRDAI Reg No</th>
                            <th>Actions</th>
                        </tr>
                    </thead>

                    <tbody>
    {insurersData.length === 0 ? (
        <tr>
            <td colSpan="4" style={{ textAlign: "center" }}>
                No insurers found
            </td>
        </tr>
    ) : (
        [...currentRecords]
            .sort((a, b) =>
                a.insurer?.toLowerCase().localeCompare(b.insurer?.toLowerCase())
            )
            .map((ins, index) => (
                <tr key={ins.company_id}>
                    {/* ✅ Serial Number */}
                    <td>{index + 1}</td>

                    <td>{ins.insurer}</td>
                    <td>{ins.irdai_reg_no}</td>

                    <td style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                        <FontAwesomeIcon
                            icon={faEdit}
                            style={{ cursor: "pointer", marginRight: "12px" }}
                            title="Edit"
                            onClick={() => {
                                setShowPopup(true);
                                setIsEdited(true);
                                setEditingInsurerId(ins.company_id);
                                setInsurer(ins.insurer);
                                setIrdai(ins.irdai_reg_no);
                            }}
                        />

                        <FontAwesomeIcon
                            icon={faTrash}
                            style={{ cursor: "pointer" }}
                            title="Delete"
                            onClick={() => handleDeleteInsurer(ins.company_id)}
                        />
                    </td>
                </tr>
            ))
    )}
</tbody>
                </table>

                {/* Pagination Controls */}
                {insurersData.length > 7 && (
                    <div className="pagination-container">

                        <FontAwesomeIcon
                            icon={faChevronLeft}
                            className={`pagination-arrow ${currentPage === 1 ? "disabled" : ""}`}
                            onClick={() => {
                                if (currentPage !== 1) {
                                    setCurrentPage(currentPage - 1);
                                }
                            }}
                        />

                        <span className="pagination-text">
                            Page {currentPage} of {totalPages}
                        </span>

                        <FontAwesomeIcon
                            icon={faChevronRight}
                            className={`pagination-arrow ${currentPage === totalPages ? "disabled" : ""}`}
                            onClick={() => {
                                if (currentPage !== totalPages) {
                                    setCurrentPage(currentPage + 1);
                                }
                            }}
                        />

                    </div>
                )}

                <br></br>
                <button className="create-insurer-btn" onClick={() => setShowTpaPopup(true)}>
                    Add TPA
                </button>

                {showTpaPopup && (
                    <div className="insurer-popup-overlay">
                        <div className="insurer-popup-card">
                            <h3>Add TPA</h3>

                            <input type="text" placeholder="TPA Name"
                                value={tpaName} onChange={e => setTpaName(e.target.value)} />

                            <input type="text" placeholder="TPA Email"
                                value={tpaEmail} onChange={e => setTpaEmail(e.target.value)} />

                            <input type="text" placeholder="TPA Phone"
                                value={tpaPhone} onChange={e => setTpaPhone(e.target.value)} />

                            <input type="text" placeholder="TPA Address"
                                value={tpaAddress} onChange={e => setTpaAddress(e.target.value)} />

                            <input type="text" placeholder="Pincode" value={pincode} onChange={e => setPincode(e.target.value)} /> 
                            <input type="text" placeholder="Registration No"
                                value={registrationNo} onChange={e => setRegistrationNo(e.target.value)} />

                            <label>CoR Valid Upto</label>
                            <input
                                type="date"
                                value={corUpto}
                                onChange={e => setCorUpto(e.target.value)}
                            />


                            {error && <p className="insurer-error">{error}</p>}

                            <div className="tpa-btn-group">
                                <button className="tpa-btn save-btn" onClick={handleSubmitTpa}>
                                    Save
                                </button>
                                <button
                                    className="tpa-btn cancel-btn"
                                    onClick={() => setShowTpaPopup(false)}
                                >
                                    Cancel
                                </button>
                            </div>

                        </div>
                    </div>
                )}



                <h3>All TPAs</h3>

                <table className="credential-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>TPA Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>CoR Valid Upto</th>
                            <th>Registration No</th>
                            <th>Actions</th>
                        </tr>
                    </thead>

                    <tbody>
    {tpaData.length === 0 ? (
        <tr>
            <td colSpan="7" style={{ textAlign: "center" }}>
                No TPAs found
            </td>
        </tr>
    ) : (
        [...currentTpaRecords]
            .sort((a, b) =>
                a.tpa_name?.toLowerCase().localeCompare(b.tpa_name?.toLowerCase())
            )
            .map((tpa, index) => (
                <tr key={tpa.tpa_id}>
                    
                    {/* ✅ Serial Number */}
                    <td>{index + 1}</td>

                    <td>{tpa.tpa_name}</td>
                    <td>{tpa.tpa_email_id}</td>
                    <td>{tpa.tpa_phone}</td>

                    <td>
                        {tpa.cor_upto
                            ? new Date(tpa.cor_upto).toISOString().split("T")[0]
                            : "-"}
                    </td>

                    <td>{tpa.registration_no}</td>

                    <td style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                        <FontAwesomeIcon
                            icon={faEdit}
                            title="Edit"
                            style={{ cursor: "pointer", marginRight: "12px" }}
                            onClick={() => {
                                setShowTpaPopup(true);
                                setIsEdited(true);
                                setEditingTpaId(tpa.tpa_id);

                                setTpaName(tpa.tpa_name);
                                setTpaEmail(tpa.tpa_email_id);
                                setTpaPhone(tpa.tpa_phone);
                                setPincode(tpa.pincode);
                                setTpaAddress(tpa.tpa_address);
                                setRegistrationNo(tpa.registration_no);
                                setCorUpto(tpa.cor_upto);
                            }}
                        />

                        <FontAwesomeIcon
                            icon={faTrash}
                            title="Delete"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleDeleteTpa(tpa.tpa_id)}
                        />
                    </td>
                </tr>
            ))
    )}
</tbody>
                </table>

                {/* ✅ SAME Pagination Style As Insurer */}
                {tpaData.length > 7 && (
                    <div className="pagination-container">

                        <FontAwesomeIcon
                            icon={faChevronLeft}
                            className={`pagination-arrow ${tpaCurrentPage === 1 ? "disabled" : ""}`}
                            onClick={() => {
                                if (tpaCurrentPage !== 1) {
                                    setTpaCurrentPage(tpaCurrentPage - 1);
                                }
                            }}
                        />

                        <span className="pagination-text">
                            Page {tpaCurrentPage} of {tpaTotalPages}
                        </span>

                        <FontAwesomeIcon
                            icon={faChevronRight}
                            className={`pagination-arrow ${tpaCurrentPage === tpaTotalPages ? "disabled" : ""}`}
                            onClick={() => {
                                if (tpaCurrentPage !== tpaTotalPages) {
                                    setTpaCurrentPage(tpaCurrentPage + 1);
                                }
                            }}
                        />

                    </div>
                )}
<br></br>

<br></br>

                <button className="template-btn" onClick={openTemplatePopup}>
                    Create Template
                </button>

                {showTemplatePopup && (
                    <div className="template-modal-overlay">
                        <div className="template-modal-box">
                            <h3>Create Template</h3>

                            <div className="template-dropdowns">
                                <label>
                                    Insurer:
                                    <select
                                        value={selectedInsurer}
                                        onChange={(e) => setSelectedInsurer(e.target.value)}
                                    >
                                        <option value="">Select Insurer</option>
                                        {insurerMasters.map((ins) => (
                                            <option key={ins.company_id} value={ins.insurer}>
                                                {ins.insurer}
                                            </option>
                                        ))}
                                    </select>
                                </label>

                                <label>
                                    Policy Type:
                                    <select
                                        value={selectedPolicyType}
                                        onChange={(e) => setSelectedPolicyType(e.target.value)}
                                    >
                                        <option value="">Select Policy Type</option>
                                        {policyTypes.map((policy) => (
                                            <option key={policy.policy_id} value={policy.policy_type}>
                                                {policy.policy_type}
                                            </option>
                                        ))}
                                    </select>
                                </label>
                            </div>

                            <p className="template-note">
                                <strong>Note:</strong> You must select at least <b>9 columns</b>. Mandatory fields:
                                <br />
                                <b>
                                    emp_email_id, emp_name, joining_date, designation, dob, emp_status, relation,
                                    cat_org_custom_name
                                </b>
                            </p>

                            <div className="template-column-list">
                                {columnList.map((col) => (
                                    <label key={col} className="template-column-item">
                                        <input
                                            type="checkbox"
                                            checked={selectedColumns.includes(col)}
                                            onChange={() => handleCheckboxChange(col)}
                                            disabled={REQUIRED_COLUMNS.includes(col)}
                                        />
                                        <span className={`checkbox-label ${REQUIRED_COLUMNS.includes(col) ? "required" : ""}`}>
                                            {col}
                                            {REQUIRED_COLUMNS.includes(col) && <span className="template-required">*</span>}
                                        </span>
                                    </label>
                                ))}
                            </div>


                            {!hasMinimumColumns && (
                                <p className="template-error">Please select at least 9 columns.</p>
                            )}
                            {hasMinimumColumns && !hasAllRequiredColumns && (
                                <p className="template-error">❌ All mandatory fields must be selected.</p>
                            )}

                            <div className="template-modal-actions">
                                <button
                                    className="template-create"
                                    onClick={createExcelTemplate}
                                >
                                    Create
                                </button>
                                <button className="template-cancel" onClick={closeTemplatePopup}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                <Footer />
            </main>
        </div>
    );
};

export default SuperAdminOrgSetup;
